import { render, staticRenderFns } from "./Stempelungen.vue?vue&type=template&id=da109bfa&scoped=true"
import script from "./Stempelungen.vue?vue&type=script&lang=ts"
export * from "./Stempelungen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da109bfa",
  null
  
)

export default component.exports